import React, { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { Icon } from '@iconify/react';
import { ConfigContext } from '../../context/GlobalContext';

const AssignMemberHighlight = () => {
    const { state } = useContext(ConfigContext);
    const navigate = useNavigate();
    const isPremium = !!state?.PREMIUM;

    const handleNavigate = () => {
        if (isPremium) {
            navigate('/members');
        } else {
            navigate('/pricing');
        }
    };

    const features = [
        { icon: 'solar:user-plus-bold', text: 'Add staff or agency members' },
        { icon: 'solar:shield-keyhole-bold', text: 'Control roles and permissions' },
        { icon: 'solar:chart-2-bold', text: 'Collaborate on business growth' },
    ];

    return (
        <div
            className="card border-0 overflow-hidden h-100 position-relative"
            style={{
                background: 'linear-gradient(135deg, #4c1d95 0%, #7c3aed 50%, #6d28d9 100%)',
                cursor: 'pointer',
                minHeight: '150px'
            }}
            onClick={handleNavigate}
        >
            {/* Decorative background circles */}
            <div
                style={{
                    position: 'absolute', top: '-40px', right: '-40px',
                    width: '180px', height: '180px', borderRadius: '50%',
                    background: 'rgba(255,255,255,0.06)', pointerEvents: 'none',
                }}
            />
            <div
                style={{
                    position: 'absolute', bottom: '-40px', left: '-20px',
                    width: '150px', height: '150px', borderRadius: '50%',
                    background: 'rgba(255,255,255,0.04)', pointerEvents: 'none',
                }}
            />

            <div className="card-body p-16 position-relative d-flex flex-column justify-content-center" style={{ zIndex: 1 }}>
                {/* Badge - Only show if not premium */}
                {!isPremium && (
                    <div className="mb-8">
                        <span
                            className="d-inline-flex align-items-center gap-1 px-8 py-2 rounded-2 fw-bold"
                            style={{
                                background: 'rgba(255,255,255,0.1)',
                                color: '#ffffff',
                                border: '1px solid rgba(255,255,255,0.2)',
                                letterSpacing: '0.5px',
                                textTransform: 'uppercase',
                                fontSize: '9px'
                            }}
                        >
                            <Icon icon="solar:crown-bold" width={10} className="text-warning" />
                            Premium
                        </span>
                    </div>
                )}

                <h4 className="fw-bold mb-12 text-white" style={{ fontSize: '18px' }}>
                    Assign Member
                </h4>

                <ul className="list-unstyled mb-24 d-flex flex-column gap-2">
                    {features.map((feature, index) => (
                        <li
                            key={index}
                            className="d-flex align-items-center gap-2 text-white"
                            style={{ opacity: 0.85 }}
                        >
                            <Icon icon={feature.icon} width={14} className="text-white" />
                            <span className="text-white fw-normal">{feature.text}</span>
                        </li>
                    ))}
                </ul>

                {/* CTA Button - Bottom */}
                <button
                    className="btn btn-white d-flex align-items-center justify-content-center gap-2 fw-bold text-xs py-8 px-16 rounded-2 mt-auto align-self-start"
                    style={{
                        background: '#ffffff',
                        color: '#7c3aed',
                        border: 'none',
                        boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
                        transition: 'all 0.3s ease',
                    }}
                >
                    {isPremium ? 'Manage Members' : 'Upgrade to Premium'}
                    <Icon icon="solar:alt-arrow-right-linear" width={16} />
                </button>
            </div>
        </div>
    );
};

export default AssignMemberHighlight;
